// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__+UJRK","contact":"Contacts_contact__YkWVU"};